import {
  DIMENSION_KEYS,
  type DimensionKey,
  type ShelterAnimal,
} from '../types';
import { parseBehaviorAttribute } from './parseAnimalAttribute';

/**
 * Builds a 7-D Likert vector from behavioral `Attributes` only (ignores staff tags like "Showable").
 * POC assumes complete data; missing dimensions fall back to `3` so the animal still ranks.
 */
export function animalBehaviorVector(
  animal: ShelterAnimal,
): Record<DimensionKey, number> {
  const vec = DIMENSION_KEYS.reduce(
    (acc, k) => {
      acc[k] = 3;
      return acc;
    },
    {} as Record<DimensionKey, number>,
  );

  for (const attr of animal.Attributes) {
    const parsed = parseBehaviorAttribute(attr.AttributeName);
    if (parsed) {
      vec[parsed.key] = parsed.level;
    }
  }

  return vec;
}
